export const EmailIntegrationStates = {
    SUCCESS: 'EMAIL_INTEGRATION_ACCOUNT_SUCCESS',
    FAILED: 'EMAIL_INTEGRATION_ACCOUNT_FAILED',
    RESET: 'EMAIL_INTEGRATION_ACCOUNT_RESET',
    DELETE: 'EMAIL_INTEGRATION_ACCOUNT_RESET',
};
